import React from 'react';
import Button from 'src/components/Button';
import FontAwesomeIcon from 'src/components/Icon';
import { Attachments } from 'src/pages/ServiceRequests/components/Attachments';
import { isImage } from 'src/helpers/CommonHelpers';
import FaqEmbed from 'src/components/Faqs/SubComponents/FawEmbed/FaqEmbed';
import './FaqItem.scss';

interface FaqItemProps {
  faq: any;
  index: number;
  hideActions: boolean;
  hideFaqActions: boolean;
  onEdit: (faq: any) => void;
  onDelete: (faq: any) => void;
  onImageClicked: (index: number, image: string) => void;
}

const FaqItem = ({
  faq,
  index,
  hideActions,
  hideFaqActions,
  onEdit,
  onDelete,
  onImageClicked,
}: FaqItemProps) => {
  const displayQuestion: string = faq.question || faq.title || '';
  const displayAnswer: string = faq.answer || faq.body || '';

  const hasAttachment: boolean = Boolean(faq.image);
  const attachmentIsImage: boolean = hasAttachment && isImage(faq.image);
  const attachmentIsPdf: boolean =
    hasAttachment && faq.image.toLowerCase().includes('.pdf');
  const fileName: string = hasAttachment
    ? faq.image.split('.com/')[1] ?? faq.image
    : '';

  return (
    <div className="faq-item">
      {hideActions && <div className="faq-item-name">{faq?.itemName}</div>}
      <div className="faq-item-question">
        {displayQuestion}
        {!hideFaqActions ? (
          hideActions && faq.faqType === 'Item' ? null : (
            <div className="faq-item-actions">
              <Button
                color="semantic"
                onClick={() => onEdit(faq)}
                label={<FontAwesomeIcon glyph="pencil" weight="light" />}
              />
              <Button
                color="semantic"
                onClick={() => onDelete(faq)}
                label={<FontAwesomeIcon glyph="trash" weight="light" />}
              />
            </div>
          )
        ) : null}
      </div>
      <div className="faq-item-answer">
        <div dangerouslySetInnerHTML={{ __html: displayAnswer }} />
      </div>
      {faq.linkTitle && <div className="faq-item-answer">{faq.linkTitle}</div>}
      <div className="faq-item-details">
        <div className="faq-item-category">{faq.issue}</div>
      </div>
      {faq.Embed && faq.Embed.length > 0 && <FaqEmbed embedCode={faq.Embed} />}
      {hasAttachment && (
        <div className="faq-item-attachment">
          <Attachments
            attachments={{
              hasAttachment: true,
              firstCompressedAttachment: attachmentIsImage
                ? faq.image
                : undefined,
              totalAttachments: 1,
            }}
            onClickAttachment={() => onImageClicked(index, faq.image)}
            fromMessages
            isPdf={attachmentIsPdf}
            fileName={fileName}
          />
        </div>
      )}
    </div>
  );
};

export default FaqItem;
